import { useState } from "react";
import { AuthFormValidator } from "../../utils/AuthFormValidator";
import { LoadingButton } from "../LoadingButton";

export function SignUpForm({
  toggleBetweenSignUpAndSignIn,
  handleSubmit,
  signUp,
}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [repeatedPassword, setRepeatedPassword] = useState("");
  const [email, setEmail] = useState("");
  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    repeatedPassword: "",
  });
  const [errors, setErrors] = useState({});

  const getUsernameFromTextInput = (e) => {
    const input = e.target.value;
    setUsername(input);
    setForm({ ...form, username: input });
  };

  const getPasswordFromTextInput = (e) => {
    const input = e.target.value;
    setPassword(input);
    setForm({ ...form, password: input });
  };

  const getRepeatedPasswordFromTextInput = (e) => {
    const input = e.target.value;
    setRepeatedPassword(input);
    setForm({ ...form, repeatedPassword: input });
  };

  const getEmailFromTextInput = (e) => {
    const input = e.target.value;
    setEmail(input);
    setForm({ ...form, email: input });
  };

  const handleSignUpResponse = async (e) => {
    e.preventDefault();
    const validationErrors = AuthFormValidator.validateSignUpForm(form);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const encryptedForm = {
        username: form.username,
        password: form.password,
        email: email,
      };

      const signUpAttempt = await signUp(encryptedForm);
      if (signUpAttempt && signUpAttempt.success) {
        setErrors(null);
        handleSubmit(e, email);
      } else if (signUpAttempt) {
        setErrors(signUpAttempt);
      }
    }
  };

  const isFormValid =
    username.trim() !== "" &&
    email.trim() !== "" &&
    password.trim() !== "" &&
    repeatedPassword.trim() !== "";

  return (
    <form onSubmit={handleSignUpResponse} className="w-full max-w-md space-y-6">
      <div className="space-y-2">
        <h2 className="text-3xl font-semibold text-gray-900">Sign Up</h2>
        <p className="text-sm text-gray-600">
          Create your account to get started
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Username</label>
          <input
            type="text"
            placeholder="Choose a username"
            value={username}
            onChange={getUsernameFromTextInput}
            autoComplete="on"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          />
          {errors.username && (
            <p className="text-xs text-red-600">{errors.username}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Email</label>
          <input
            type="text"
            placeholder="Enter your email"
            value={email}
            onChange={getEmailFromTextInput}
            autoComplete="on"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          />
          {errors.email && (
            <p className="text-xs text-red-600">{errors.email}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">Password</label>
          <input
            type="password"
            placeholder="Create a password"
            value={password}
            onChange={getPasswordFromTextInput}
            autoComplete="on"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          />
          {errors.password && (
            <p className="text-xs text-red-600">{errors.password}</p>
          )}
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium text-gray-700">
            Repeat Password
          </label>
          <input
            type="password"
            placeholder="Confirm your password"
            value={repeatedPassword}
            onChange={getRepeatedPasswordFromTextInput}
            autoComplete="on"
            className="w-full px-4 py-3 border border-gray-200 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-transparent"
          />
          {errors.repeatedPassword && (
            <p className="text-xs text-red-600">{errors.repeatedPassword}</p>
          )}
        </div>
      </div>

      {errors.general && (
        <p className="text-sm text-red-600">{errors.general}</p>
      )}

      <LoadingButton
        type="submit"
        label="Sign Up"
        disabled={!isFormValid}
        onClick={handleSignUpResponse}
        style={`w-full px-4 py-3 rounded-lg text-base font-medium transition-colors ${
          isFormValid
            ? "bg-gray-900 text-white hover:bg-gray-800"
            : "bg-gray-300 text-gray-500 cursor-not-allowed"
        }`}
      />

      <div className="text-center">
        <button
          type="button"
          onClick={toggleBetweenSignUpAndSignIn}
          className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
        >
          Already have an account? <span className="font-medium">Sign in!</span>
        </button>
      </div>
    </form>
  );
}
